import { z } from "zod";

import { intIdCodec, intIdSchema } from "@/codecs/intId";

export const coreCredentialStatusIdSchema =
  intIdSchema.brand<"CoreCredentialStatusId">();
export type CoreCredentialStatusId = z.infer<
  typeof coreCredentialStatusIdSchema
>;

export const cohireCredentialStatusSchema = z
  .string()
  .min(1)
  .brand<"CohireCredentialStatus">();
export type CohireCredentialStatus = z.infer<
  typeof cohireCredentialStatusSchema
>;

export const credentialStatusIdSchema = z.union([
  coreCredentialStatusIdSchema,
  cohireCredentialStatusSchema,
]);
export type CredentialStatusId = z.infer<typeof credentialStatusIdSchema>;

export const coreCredentialStatusIdCodec = intIdCodec(
  coreCredentialStatusIdSchema,
);
